export const TOKEN_KEY = "Authorization";
export const GLOBAL_MD5 = "ifan";
